export default "__VITE_ASSET__CBTDGZ5b__"